import { z } from 'zod/v4';
import { ToolName } from './tools';
export const AssistantMessageSchema = z.object({
    content: z.string(),
    citations: z
        .array(z.object({
        id: z.string(),
        toolName: z.enum(ToolName),
        // Quote text - required for knowledgeSearch, optional for FDA tools
        quote: z.string().optional(),
        // File-specific fields - only for knowledgeSearch citations
        fileId: z.string().optional(),
        fileName: z.string().optional(),
        pageNumber: z.number().optional(),
    }))
        .min(1)
        .max(5),
    followUpQuestions: z.array(z.string()).optional(),
});
export * from './metadata';
export * from './region';
//# sourceMappingURL=index.js.map